// src/components/network/ForfeoExperienceTrustPanel.tsx
import { ArrowRight, CheckCircle2, QrCode, ShieldCheck, Smartphone, WalletCards } from 'lucide-react';
import { buildForfeoMobileDeepLink } from '../../lib/forfeoNetwork';
import { ForfeoNetworkBadges } from './ForfeoNetworkBadges';

type ForfeoExperienceTrustPanelProps = {
  experienceId?: string | number | null;
  title?: string | null;
  className?: string;
};

const items = [
  {
    icon: ShieldCheck,
    title: 'Achat protégé par Forfeo',
    text: 'Forfeo agit comme tiers de confiance entre le client et le partenaire.',
  },
  {
    icon: WalletCards,
    title: 'Pass ajouté au wallet',
    text: 'Prépare le passage vers les cartes cadeaux, pass expériences et réservations mobiles.',
  },
  {
    icon: QrCode,
    title: 'QR sécurisé',
    text: 'Chaque utilisation pourra être validée par le partenaire avec un code unique.',
  },
];

export function ForfeoExperienceTrustPanel({ experienceId, title, className = '' }: ForfeoExperienceTrustPanelProps) {
  const appLink = buildForfeoMobileDeepLink({
    target: 'experience',
    id: experienceId ? String(experienceId) : undefined,
    source: 'forfeo_explore',
    fallbackUrl: 'https://forfeoexplore.com/boutique',
  });

  return (
    <section className={`rounded-3xl border border-slate-200 bg-white p-6 shadow-sm ${className}`.trim()}>
      <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <div className="mb-3">
            <ForfeoNetworkBadges variant="full" />
          </div>
          <h2 className="text-xl font-black text-slate-900">
            Expérience prête pour le réseau Forfeo
          </h2>
          <p className="mt-2 max-w-2xl text-sm font-medium leading-relaxed text-slate-600">
            {title ? `${title} est préparée pour le wallet, les QR codes et la réservation mobile.` : 'Cette expérience est préparée pour le wallet, les QR codes et la réservation mobile.'}
          </p>
        </div>
        <a
          href={appLink}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl bg-slate-900 px-5 py-3 text-xs font-black uppercase tracking-[0.16em] text-white shadow-lg shadow-slate-900/15 transition hover:-translate-y-0.5 hover:bg-purple-700"
        >
          <Smartphone size={16} /> Réserver dans l’app <ArrowRight size={15} />
        </a>
      </div>

      <div className="mt-6 grid gap-3 md:grid-cols-3">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.title} className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
              <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-white text-purple-600 shadow-sm">
                <Icon size={18} />
              </div>
              <h3 className="text-sm font-black text-slate-900">{item.title}</h3>
              <p className="mt-1 text-xs font-medium leading-relaxed text-slate-500">{item.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default ForfeoExperienceTrustPanel;
